export const VIEW_MODES = {
  EXTENDED: 'extended',
  COMPACT: 'compact',
};
